// selectors
import { getUI } from "Selectors/ui";

export const getEmail = (state) => getUI(state).get("email", "");
export const getPassword = (state) => getUI(state).get("password", "");
